import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgRsProfilePlaceholderS = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        d: "M12 0c6.627 0 12 5.372 12 12 0 1.853-.42 3.608-1.17 5.175a4 4 0 1 0-5.656 5.656A11.95 11.95 0 0 1 12 24C5.373 24 0 18.627 0 12 0 5.372 5.373 0 12 0"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        d: "M12.424 5.026a3.83 3.83 0 0 1 3.828 3.829v2.142a3.8 3.8 0 0 1-1.23 2.808 1.65 1.65 0 0 0 .073 2.493c.266.214.569.388.902.509.35.127.725.27 1.11.429A4 4 0 0 0 16 20c0 .665.162 1.291.449 1.843A10.75 10.75 0 0 1 12 22.8a10.77 10.77 0 0 1-8.08-3.637.265.265 0 0 1 .043-.39c1.178-.83 2.774-1.507 4.04-1.966.333-.121.637-.295.902-.51.782-.632.811-1.81.072-2.492a3.81 3.81 0 0 1-1.23-2.808V8.855a3.83 3.83 0 0 1 3.83-3.829z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.06,
        fillRule: "nonzero",
        d: "M12 0c6.525 0 11.834 5.208 11.996 11.695L24 12l-.004.305a11.9 11.9 0 0 1-1.166 4.87 4 4 0 0 0-.39-.345 11.4 11.4 0 0 0 1.056-4.538L23.5 12l-.004-.292C23.341 5.49 18.254.5 12 .5 5.649.5.5 5.649.5 12S5.649 23.5 12 23.5c1.726 0 3.362-.38 4.831-1.061q.158.208.343.391A11.95 11.95 0 0 1 12 24C5.373 24 0 18.627 0 12S5.373 0 12 0"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgRsProfilePlaceholderS$1 = SvgRsProfilePlaceholderS;

export { SvgRsProfilePlaceholderS$1 as default };
